import { CART_MODULE } from "@/api_framework/api_config";
import { ICartDetailsResponse, ICartDetailsResponseData } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useSnapmintEmiStatusAPI = () => {
  const configuration = useConfiguration();
  const [emi_status, setEmi_status] = useState<any>(null);
  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (
     order_id:string
    ) => {
      try {
      
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartDetailsResponseData | null = await axios
          .get(`${CART_MODULE?.SNAPMINT_EMI_STATUS?.baseURL}?order_id=${order_id}`, {
            params: {
             
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICartDetailsResponse>) => {
            if (res.data.status === true) {
             setEmi_status(res.data.data);
              return res.data.data;
            } else {
              setEmi_status(null);
              return null;
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            setEmi_status(null);
            sendCurl(e.config["curlCommand"]);
          
            return null;
          });
        return response;
      } catch (e) {
       
        captureError(e);  
      }
    },
    [dispatch],
  );
  return { emi_status, execute };
};
